var getUrlWithRn = function getUrlWithRn(path, rn) {
  return "".concat(path, "?rn=").concat(rn);
};

/**
 * return localized url
 *
 * @param string url
 * @param string locale
 *
 */

var getLocalizeUrl = function getLocalizeUrl(url, locale) {
  if (!url) return '/';
  return !locale || locale.toLowerCase() === 'en_us' || locale.toLowerCase() === 'zh_cn' ? url : "/".concat(locale).concat(url);
};
var getFormattedUrl = function getFormattedUrl(url, locale, rn) {
  var formattedUrl = getLocalizeUrl(url, locale);
  return getUrlWithRn(formattedUrl, rn);
};

export { getFormattedUrl, getLocalizeUrl, getUrlWithRn };
